class Modal extends HTMLElement {
  // Initialize some private variables here if needed, or inside the constructor.
  // readonly _selectContainer: HTMLElement;
  rendered = false;

  constructor() {
    // This is always needed to pull everything from the HTMLElement class.
    super();
  }

  /* Called when component is loaded */
  /* Getting called three times for some reason */
  connectedCallback() {
    if (!this.rendered) {
      this._render();
      this._attachEventHandlers();
      this._handleOptionalFields();
    }
  }

  private _render() {
    const wrapperClass = this.visible ? 'wrapper visible' : 'wrapper';
    const template = document.createElement('template');
    template.innerHTML = `
        <style>
          .wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            position: fixed;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background: rgb(0 0 0 / 30%);
            opacity: 0;
            visibility: hidden;
            z-index: 1; }
          .visible {
            opacity: 1;
            visibility: visible; }
          .modal {
            font-family:'Metropolis', Arial, sans-serif;
            font-size: 14px;
            display: flex;
            flex-direction: column;
            padding: 32px 0;
            background-color: #fff;
            box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
            border-radius: 4px;
            max-height: 80vh;
            width: 550px;
            max-width: 100%;
            transform: scale(0.9);
            transition: visibility 0s linear 0.25s,opacity 0.25s 0s,transform 0.25s; }
          .visible .modal {
            transform: scale(1);
            transition: visibility 0s linear 0s,opacity 0.25s 0s,transform 0.25s;
          }
          .header {
            padding: 0 32px 24px;
            border-bottom: 1px solid var(--neutral-20);
            position: relative;
            display: flex;
            justify-content: space-between; }
          .title {
            color: #771B61;
            font-size: 1.25rem;
            font-weight: 700;
            line-height: 1.4em;
            margin: 0; }
          .close-btn {
            appearance: none;
            border: none;
            outline: none;
            background: transparent;
            position: absolute;
            right: 32px;
            top: -10px;
            cursor: pointer; }
          .content {
            height: 100%;
            padding: 10px 32px 24px; }
          .button-container {
            padding: 24px 32px 0;
            border-top: 1px solid var(--neutral-20);
            display: flex;
            justify-content: flex-end; }
          .primary-btn,
          .secondary-btn {
            border-radius: 3px;
            font-family:'Metropolis', Arial, sans-serif;
            font-weight: 600;
            cursor: pointer;
            min-width: 174px;
            height: 40px;
            border: 1px solid var(--brand-50); }
          .primary-btn {
            color: #fff;
            background: var(--brand-50); }
          .secondary-btn {
            background: transparent;
            color: var(--brand-50);
            margin: 0 24px 0 0; }
          ::slotted(p) {
            margin: 1em 0 0 !important; }
        </style>`;

    template.innerHTML += `
        <div class='${wrapperClass}'>
          <div part="modal" class='modal' role="dialog">
            <div class="header">
              <p class='title'>${this.title}</p>
              <button class="close-btn" aria-label="Close dialog to continue editing"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.88663 6.00094L11.0666 2.82094C11.1442 2.74353 11.2058 2.65157 11.2478 2.55033C11.2898 2.44909 11.3115 2.34055 11.3115 2.23094C11.3115 2.12133 11.2898 2.0128 11.2478 1.91155C11.2058 1.81031 11.1442 1.71835 11.0666 1.64094L10.36 0.934276C10.2826 0.856671 10.1906 0.795099 10.0894 0.753089C9.98811 0.711078 9.87958 0.689453 9.76997 0.689453C9.66035 0.689453 9.55182 0.711078 9.45058 0.753089C9.34934 0.795099 9.25738 0.856671 9.17997 0.934276L5.99997 4.11428L2.81997 0.934276C2.74256 0.856671 2.6506 0.795099 2.54936 0.753089C2.44811 0.711078 2.33958 0.689453 2.22997 0.689453C2.12035 0.689453 2.01182 0.711078 1.91058 0.753089C1.80933 0.795099 1.71738 0.856671 1.63997 0.934276L0.9333 1.64094C0.855694 1.71835 0.794123 1.81031 0.752112 1.91155C0.710101 2.0128 0.688477 2.12133 0.688477 2.23094C0.688477 2.34055 0.710101 2.44909 0.752112 2.55033C0.794123 2.65157 0.855694 2.74353 0.9333 2.82094L4.1133 6.00094L0.9333 9.18094C0.855694 9.25835 0.794123 9.35031 0.752112 9.45155C0.710101 9.5528 0.688477 9.66133 0.688477 9.77094C0.688477 9.88056 0.710101 9.98909 0.752112 10.0903C0.794123 10.1916 0.855694 10.2835 0.9333 10.3609L1.63997 11.0676C1.71738 11.1452 1.80933 11.2068 1.91058 11.2488C2.01182 11.2908 2.12035 11.3124 2.22997 11.3124C2.33958 11.3124 2.44811 11.2908 2.54936 11.2488C2.6506 11.2068 2.74256 11.1452 2.81997 11.0676L5.99997 7.88761L9.17997 11.0676C9.25738 11.1452 9.34934 11.2068 9.45058 11.2488C9.55182 11.2908 9.66035 11.3124 9.76997 11.3124C9.87958 11.3124 9.98811 11.2908 10.0894 11.2488C10.1906 11.2068 10.2826 11.1452 10.36 11.0676L11.0666 10.3609C11.1442 10.2835 11.2058 10.1916 11.2478 10.0903C11.2898 9.98909 11.3115 9.88056 11.3115 9.77094C11.3115 9.66133 11.2898 9.5528 11.2478 9.45155C11.2058 9.35031 11.1442 9.25835 11.0666 9.18094L7.88663 6.00094Z" fill="#232526"/></svg></button>
            </div>
            <div class='content'>
              <slot></slot>
            </div>
            <div class='button-container'>
              <button class='secondary-btn'>${this.secondaryText}</button>
              <button class='primary-btn'>${this.primaryText}</button>
            </div>
          </div>
        </div>
      `;

    // Create the shadowRoot and append the template.
    this.attachShadow({ mode: 'open' });
    this.shadowRoot.appendChild(template.content.cloneNode(true));
    this.rendered = true;
  }

  _attachEventHandlers() {
    const secondaryBtn = this.shadowRoot.querySelector('.secondary-btn');
    secondaryBtn.addEventListener('click', (e) => {
      this.dispatchEvent(new CustomEvent('secondaryClick', { bubbles: true, composed: true }));
    });
    const primaryBtn = this.shadowRoot.querySelector('.primary-btn');
    primaryBtn.addEventListener('click', (e) => {
      this.dispatchEvent(new CustomEvent('primaryClick', { bubbles: true, composed: true }));
    });
    const closeBtn = this.shadowRoot.querySelector('.close-btn');
    closeBtn.addEventListener('click', (e) => {
      this.dispatchEvent(new CustomEvent('closeClick', { bubbles: true, composed: true }));
    });
  }

  _handleOptionalFields() {
    if (!this.title) {
      const title = this.shadowRoot.querySelector('.title');
      title.remove();
    }
    if (!this.secondaryText) {
      const secondaryBtn = this.shadowRoot.querySelector('.secondary-btn');
      secondaryBtn.remove();
    }
  }

  static get observedAttributes() {
    return ['title', 'visible', 'secondaryText', 'primaryText'];
  }

  get title() {
    return this.getAttribute('title');
  }

  set title(value) {
    this.setAttribute('title', value);
  }

  get primaryText() {
    return this.getAttribute('primaryText');
  }

  set primaryText(value) {
    this.setAttribute('primaryText', value);
  }

  get secondaryText() {
    return this.getAttribute('secondaryText');
  }

  set secondaryText(value) {
    this.setAttribute('secondaryText', value);
  }

  get visible() {
    return this.hasAttribute('visible');
  }

  set visible(value) {
    if (value) {
      this.setAttribute('visible', '');
    } else {
      this.removeAttribute('visible');
    }
  }

  attributeChangedCallback(attributeName, oldValue, newValue) {
    if (attributeName === 'visible') {
      const wrapper = this.shadowRoot.querySelector('.wrapper');
      if (this.visible) {
        wrapper.classList.add('visible');
      } else {
        wrapper.classList.remove('visible');
      }
    }
  }

  disconnectedCallback() {
    // console.log('disconnectedCallback()');
  }
}
window.customElements.define('ods-modal', Modal);
